





















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({

})
export default class BaseModal extends Vue {
    @Model('update:open' ,{ required: true }) readonly  open!: boolean
    @Prop({ default: ''}) title!: string

    get openWrapper() {
        return this.open;
    }

    set openWrapper(open) {
        this.$emit('update:open', open);
    }

    closeModal() {
        this.openWrapper = false;
    }
}
